import { Box, Link, Text } from "@radix-ui/themes";

const About: React.FC = () => {
  return (
    <Box>
      <Text>
        This is a directory of active jazz jams throughout the UK. It's currently a work in progress and by no means an exhaustive list.
        If you have any questions, or want me to add more jams, feel free to <Link href="mailto:soundtomb1@gmail.com">send me an email</Link>.
      </Text>
      <br />
      <br />
      <Text>
        You can also check out my other projects at my website, <Link href="https://soundtomb.com" target="_blank">soundtomb.com</Link>.
      </Text>
      <br />
      <br />
    </Box>
  );
};

export default About;
